/**
 * FeedbackEvents — flagAck and flag-write errors.
 */
const FeedbackEvents = {
  /**
   * @param {Socket} socket
   * @param {GameState} gameState
   * @param {Object} callbacks
   * @param {object} callbacks.flagStore
   * @param {Function} callbacks.notifyError
   * @param {Function} [callbacks.onComposeAck]
   */
  register(socket, gameState, callbacks) {
    const { flagStore, notifyError = () => {}, onComposeAck } = callbacks;
    socket.on('flagAck', (data) => {
      if (gameState?.currentRoomId) flagStore.setRoom(gameState.currentRoomId);
      flagStore.add(data);
      if (flagStore.awaitCompose) {
        flagStore.awaitCompose = false;
        if (typeof onComposeAck === 'function') onComposeAck(data);
      }
    });
    socket.on('error', (data) => {
      if (data?.message === "Couldn't save flag") notifyError(data.message);
    });
  }
};

export { FeedbackEvents };
